
import http_request from './http_request'

import config from 'config'

function getColors() {
	return http_request.post(config.services + 'userCategories/getColors')
		.send({})
}

export default {
	getColors,
}
